import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import SectionAbout from 'app/components/homes/SectionAbout';
import { withGlobalData } from 'app/utils/withGlobalData';
import WhyLearn from 'app/components/homes/WhyLearn';
import { useTranslation } from 'next-i18next';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import env from '.env.json';

export default function Home() {
  const { t } = useTranslation('common');

  return (
    <section className="box-card-area">
      <Head>
        <title>{t('commons.home')}</title>
      </Head>
      <NextSeo
        description={t('home.introduce', { name: env.APP_NAME })}
      />

      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div id="home-page" className='content_inner'>
              <SectionAbout />
              <WhyLearn />
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common']),
    },
  }
});
